<template>
<div>
  <div class="form-group">
    <label for="">
      {{ label }}
    </label>
    <select :name="effectiveSelectName" id="" class="form-control" v-model="criteriaSelected">
      <option v-for="(name, value, index) in selectValues"
              :key="index" :value="value">
        {{ name }}
      </option>
    </select>
  </div>

  <div class="form-group" v-show="this.criteriaSelected === this.type">

    <VariantsSelect
        :activities-url="activitiesUrl"
        :activity-variants-in-rule="activityVariants"
        :label="label"
        :activities="activities"
        :criteriaSelected="criteriaSelected"
        :field-name="type === 'activity' ? 'rules[0][value]' : 'actions[0][apply_to]'"
    ></VariantsSelect>
  </div>
</div>
</template>

<script>
import VariantsSelect from "./VariantsSelect.vue";

export default {
  components: {
    VariantsSelect,
  },
  props: {
    activitiesUrl: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    activityVariants: {
      type: Array,
      default: function () {
        return []
      }
    },
    activities: {
      required: true,
      type: Array,
    },
    selectValues: {
      required: true,
      type: Object,
    },
    type: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      selectName: this.type === 'activity' ? 'rules[0][type]' : '',
      criteriaSelected: this.activityVariants.length === 0 ? "all" : this.type,
    }
  },
  computed: {
    // "all" means no rule is configured, so the field must not be submitted —
    // otherwise the server rejects the unknown type during validation.
    effectiveSelectName() {
      return this.criteriaSelected === 'all' ? '' : this.selectName;
    },
  },
}
</script>

<style scoped>

</style>